import { Identifier } from "../../id";
export class CrossSellingItemTypeId extends Identifier {
    constructor(id) {
        super("CrossSellingItemTypeId", id);
    }
}
